import { EventType, FilterDimension } from "src/store/api/generatedApi";
import {
  EVENT_TYPE_VALUES,
  FILTER_DIMENSION_VALUES,
  MaterialAreaFilter,
  parseEventLimit,
} from "components/manualReview/filters/eventFilters";
import { Serialiser } from "./types";

const PAIR_SEP = "~";
const NEGATED_SEP = ".";

const parseEventType = (value: string | undefined): EventType | null =>
  value !== undefined &&
  (EVENT_TYPE_VALUES as readonly string[]).includes(value)
    ? (value as EventType)
    : null;

const parseNegated = (value: string | undefined): FilterDimension[] =>
  value === undefined || value === ""
    ? []
    : value
        .split(NEGATED_SEP)
        .filter((dimension): dimension is FilterDimension =>
          (FILTER_DIMENSION_VALUES as readonly string[]).includes(dimension)
        );

export const materialAreaListSerialiser: Serialiser<
  MaterialAreaFilter[],
  never
> = {
  format: (value) =>
    value
      .map((filter) =>
        [
          filter.material ?? "",
          filter.area ?? "",
          filter.eventType ?? "",
          filter.limitTo ?? "",
          (filter.negated ?? []).join(NEGATED_SEP),
        ].join(PAIR_SEP)
      )
      .join(","),
  parse: (text) => {
    if (text.length === 0) return { valid: true, value: [] };
    const value = text.split(",").flatMap((token) => {
      const parts = token.split(PAIR_SEP);
      if (parts.length < 2) return [];
      const [material, area, eventType, limitTo, negated] = parts;
      return [
        {
          material: material === undefined || material === "" ? null : material,
          area: area === undefined || area === "" ? null : area,
          eventType: parseEventType(eventType),
          limitTo: parseEventLimit(limitTo ?? ""),
          negated: parseNegated(negated),
        },
      ];
    });
    return { valid: true, value };
  },
};
